import qs from 'qs'
import request from '@/utils/request'
import type { BoardFileUrl, BoardPostDetail, BoardPostSummary, CreateBoardPostReq, GetBoardPostsReq, UpdateBoardPostReq } from './types'

export const BOARD_POSTS_URL = '/api/v1/board/posts'

/** Spring `List<String>` 쿼리는 `shipperCodes=A&shipperCodes=B` 로 받는다 — 빈 값은 보내지 않는다. */
const toQuery = (params: GetBoardPostsReq): string =>
  qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true, filter: (_: string, value: unknown) => (value === '' ? undefined : value) })

export const getBoardPosts = (params: GetBoardPostsReq) =>
  request.get<ApiResponseV2<ApiPageResponse<BoardPostSummary>>>(`${BOARD_POSTS_URL}?${toQuery(params)}`)

/** 열 때마다 서버가 조회수를 1 올린다. */
export const getBoardPost = (id: number) => request.get<ApiResponseV2<BoardPostDetail>>(`${BOARD_POSTS_URL}/${id}`)

/** presign 5분 — 누를 때마다 새로 받는다. */
export const getBoardFileUrl = (id: number, index: number) => request.get<ApiResponseV2<BoardFileUrl>>(`${BOARD_POSTS_URL}/${id}/files/${index}`)

export const createBoardPost = (body: CreateBoardPostReq) => request.post<ApiResponseV2<number>, CreateBoardPostReq>(BOARD_POSTS_URL, body)

export const updateBoardPost = (id: number, body: UpdateBoardPostReq) =>
  request.put<ApiResponseV2<unknown>, UpdateBoardPostReq>(`${BOARD_POSTS_URL}/${id}`, body)

export const deleteBoardPost = (id: number) => request.delete<ApiResponseV2<unknown>>(`${BOARD_POSTS_URL}/${id}`)

export const createBoardComment = (id: number, comment: string) =>
  request.post<ApiResponseV2<number>, { comment: string }>(`${BOARD_POSTS_URL}/${id}/comments`, { comment })

export const deleteBoardComment = (id: number, commentId: number) =>
  request.delete<ApiResponseV2<unknown>>(`${BOARD_POSTS_URL}/${id}/comments/${commentId}`)
